export default __webpack_public_path__ + "static/media/progress_empty.90b93b4a.png";